module.exports = __webpack_public_path__ + "images/category_lp/watch/case5_eedc20513e279ab5e7da7035ad88f961.jpg";